import { Pipe, PipeTransform } from "@angular/core";
import { AttachmentV2 } from "src/app/backend/models/attachment/attachment";

@Pipe({
  name: "attachmentIsSigned",
  standalone: false
})
export class AttachmentIsSignedPipe implements PipeTransform {
  transform(attachment: AttachmentV2): boolean {
    return !!attachment.signature && !!attachment.signature.completedAt;
  }
}
